import Link from 'next/link';
import { FaWhatsapp } from 'react-icons/fa';
import { phoneNumber } from '@/lib/data';

export default function WhatsappBtn() {
  return (
    <Link
      href={`https://wa.me/39` + phoneNumber}
      className="fixed bottom-4 right-5 p-2 bg-green-500 rounded-full z-50"
      aria-label="WhatsApp">
      <FaWhatsapp className="text-4xl text-white" />
    </Link>
  );
}
